
import { useCallback } from 'react';
import { useToggleResearchFavorite, type ResearchLibraryItem } from '@/hooks/research-generator';

interface UseResearchMatrixFavoritesProps {
  allResearch: ResearchLibraryItem[];
}

export const useResearchMatrixFavorites = ({ allResearch }: UseResearchMatrixFavoritesProps) => {
  const toggleFavoriteMutation = useToggleResearchFavorite();

  const handleToggleFavorite = useCallback(async (researchId: string): Promise<void> => {
    const item = allResearch.find(r => r.id === researchId);
    if (!item) return;
    
    const isFavorited = item.is_favorited;
    
    return new Promise((resolve, reject) => {
      toggleFavoriteMutation.mutate(
        { researchId, isFavorited: !!isFavorited },
        {
          onSuccess: () => {
            console.log('Favorite toggled successfully');
            resolve();
          },
          onError: (error) => {
            console.error('Failed to toggle favorite:', error);
            reject(error);
          }
        }
      );
    });
  }, [allResearch, toggleFavoriteMutation]);

  return {
    handleToggleFavorite,
  };
};
